/* eslint-disable max-len */
/* eslint-disable consistent-return */

export default {

    methods: {

        /**
         * @override
         */
        showModal(idModal) {
            this.$bvModal.show(idModal);
        },

        /**
         * @override
         */
        hideModal(idModal) {
            this.$bvModal.hide(idModal);
        }

    }
};
